import { Home, Car, ArrowUpRight } from "lucide-react";
import { COTAS_URL } from "../../lib/site";

const SEGMENTS = [
  { id: "imoveis", key: "imovel", Icon: Home, title: "Imóvel", text: "Cartas contempladas para quem quer avançar na compra de um imóvel." },
  { id: "veiculos", key: "veiculo", Icon: Car, title: "Veículo", text: "Cartas contempladas para quem quer avançar na compra de um veículo." },
];

const SegmentCard = ({ s }) => (
  <a id={s.id} href={COTAS_URL} target="_blank" rel="noopener noreferrer" data-testid={`segment-card-${s.key}`}
    className="group relative flex scroll-mt-28 flex-col justify-between overflow-hidden rounded-[28px] border border-[#C8D7E4] bg-white p-8 transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-1 hover:border-[#218FFF] hover:shadow-[0_20px_50px_-20px_rgba(25,106,188,0.35)] sm:p-10">
    <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#196ABC]/10 text-[#196ABC] transition-colors group-hover:bg-[#196ABC] group-hover:text-[#F7F5F0]">
      <s.Icon className="h-8 w-8" strokeWidth={2.5} />
    </div>
    <div className="mt-14">
      <h3 className="text-3xl font-extrabold uppercase tracking-tight text-[#15579A] sm:text-4xl">{s.title}</h3>
      <p className="mt-3 max-w-sm text-base leading-relaxed text-[#15579A]/75">{s.text}</p>
      <span className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#196ABC] group-hover:text-[#218FFF]">
        Ver cartas disponíveis <ArrowUpRight className="h-4 w-4" strokeWidth={2.5} />
      </span>
    </div>
  </a>
);

export const Segments = () => (
  <section className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-32" data-testid="segments-section">
    <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#218FFF]">Escolha seu segmento</p>
    <h2 className="mt-3 max-w-2xl text-3xl font-extrabold uppercase tracking-tight text-[#15579A] sm:text-4xl">O crédito certo.</h2>
    <p className="mt-3 text-base font-medium text-[#196ABC] md:text-lg">Escolha o que você quer conquistar e veja as cartas disponíveis.</p>
    <div className="mt-12 grid gap-6 md:grid-cols-2">
      {SEGMENTS.map((s) => <SegmentCard key={s.key} s={s} />)}
    </div>
    <div className="mt-8 flex justify-center">
      <a href={COTAS_URL} target="_blank" rel="noopener noreferrer" data-testid="segment-ver-todas-btn"
        className="inline-flex items-center gap-2 rounded-full bg-[#196ABC] px-8 py-4 text-base font-semibold text-[#F7F5F0] transition-colors hover:bg-[#218FFF] active:bg-[#15579A]">
        Ver todas as cartas <ArrowUpRight className="h-5 w-5" strokeWidth={2.5} />
      </a>
    </div>
  </section>
);
